import MultiTranslateHttpLoaderFactory from './multi-translate-loader-factory';

export default MultiTranslateHttpLoaderFactory;
